function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.574 5.355l-.012.01-3.45-3.45a.847.847 0 10-1.197 1.198l3.34 3.34L5 6.668H2.5a.833.833 0 00-.833.833v5c0 .46.373.833.833.833H5l4.317 3.597a.417.417 0 00.683-.32v-5.412l1.667 1.666v.47c.149 0 .296-.01.44-.03l1.36 1.362a4.987 4.987 0 01-1.8.334v1.667a6.638 6.638 0 003.06-.743l2.16 2.161a.847.847 0 101.198-1.198l-1.945-1.944.011-.01-1.18-1.18-.01.01-1.183-1.183.011-.01-1.189-1.189a.929.929 0 01-.012.009L10 8.802v-.02L8.333 7.114v.02l-.587-.587.011-.01-1.183-1.183zm5.403 3.007l-.31-.31V6.667a3.333 3.333 0 013.12 4.506L13.306 9.69a1.668 1.668 0 00-1.328-1.328zm4.063 4.063l1.213 1.214a6.667 6.667 0 00-5.587-10.306V5a5 5 0 014.374 7.425zM10 6.385L7.88 4.267 9.318 3.07a.417.417 0 01.683.32v2.996zM5.603 8.334l.836-.696L8.333 9.53v4.41l-2.73-2.274h-2.27V8.333h2.27z",
  fill: "#fff"
});

var SvgStopAudioShare = function SvgStopAudioShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none"
  }), _ref);
};

export default SvgStopAudioShare;